var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemThumbsDownCircleFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2 12C2 6.478 6.478 2 12 2s10 4.478 10 10-4.478 10-10 10S2 17.522 2 12m5.955-3 6.08-.004v4.573s-.5.336-.788.576c-1.116.925-2.048 2.851-2.048 2.851a1.05 1.05 0 0 1-.716-.262c-.107-.098-.277-.306-.224-.605l.225-1.256.233-1.304H8.005c-2.23 0-.05-4.57-.05-4.57M17 8.995h-2.01v4.57H17z",
  clipRule: "evenodd"
})));
export default SvgGemThumbsDownCircleFilled;